import React, { useState } from 'react';
import { db, collection, addDoc } from '../../firebase';
import './DataDeletionRequestForm.css';

const DataDeletionRequestForm = () => {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [dob, setDob] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!name || !number || !dob) {
      setMessage('Please fill in all fields.');
      return;
    }

    try {
      await addDoc(collection(db, "deletionuserdata"), {
        name,
        number,
        dob,
        timestamp: new Date()
      });
      setMessage('Request submitted successfully!');
      setName('');
      setNumber('');
      setDob('');
    } catch (e) {
      console.error("Error adding document: ", e);
      setMessage('Failed to submit request. Please try again.');
    }
  };

  return (
    <div className="data-deletion-form-container">
      <form onSubmit={handleSubmit} className="data-deletion-form">
        <h2>Data Deletion Request</h2>
        {message && (
          <p className={message.includes('successfully') ? 'success-message' : 'error-message'}>
            {message}
          </p>
        )}
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your Name"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="number">Mobile Number:</label>
          <input
            type="tel"
            id="number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="Your Mobile Number"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="dob">Date of Birth:</label>
          <input
            type="date"
            id="dob"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            required
          />
        </div>
        <div className="form-actions">
          <button
            type="submit"
            className="submit-button"
          >
            Submit Request
          </button>
        </div>
      </form>
    </div>
  );
};

export default DataDeletionRequestForm;